import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {isNewUser, sendNewMusicianAPI} from 'src/API/newMusician'
import {
  Box,
  Grid,
  Typography,
  makeStyles,
  CssBaseline,
  Link,
  Avatar
} from '@material-ui/core';
import Page from 'src/components/Page';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Wave from 'react-wavify';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { firebase } from '../../db/db';
import PopupMusician from './PopupMusician';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#53131E',
    backgroundSize: 'cover',
    height: '100%',
    backgroundPosition: 'center',
    width: '100%',
    paddingTop: '40px'
  },
  page: {
    height: '100%'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  },
  paper: {
    margin: theme.spacing(6, 6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://voicefirsttech.com/">
        Voice First AI{' '}
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const LoginView = props => {
  const classes = useStyles();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState();
  const [popupIsOpen, setPopupIsOpen] = useState(false);
  const [popupIsLoading, setPopupIsLoading] = useState(false);
  const [popupErrorText, setPopupErrorText] = useState("");

  const configureFirebaseUi = () => {
    return {
      signInFlow: 'popup',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccessWithAuthResult: async (authResult, redirectUrl) => {
          return false;
        }
      }
    };
  };

  const authSendNewMusicianApi = async(musicianName, email, uid) => {
    setPopupErrorText(false);
    const response = await sendNewMusicianAPI(musicianName, email, uid)
    console.log(response.data)
    if (typeof response.data === "string") {
      setPopupIsOpen(true);
      setPopupIsLoading(false);
      setPopupErrorText("Error: " + musicianName + " already exists. Please pick a new name.");
    } else {
      return navigate('/app/account/', {
        state: musicianName,
        replace: false
      });
    }
  };

  // Configure FirebaseUI.
  let uiConfig = configureFirebaseUi();
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        setUser(user);
        // Is this a new user?
        const isNew = await isNewUser(user);
        if (isNew) {
          if (state) { // Send NewMusician API. 
            await authSendNewMusicianApi(state, user.email, user.uid);
          } else { // Open popup to get musician name.
            setPopupIsOpen(true);
          } 
        } else {// Existing users are redirected to dashboard.
          return navigate('/app/account/', {
            state: state,
            replace: false
          });
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state,navigate, user, popupIsOpen]);
  return (
    <Page
      className={classes.root}
      title="Login"
      style={{ backgroundColor: '#FAC9B8' }}
    >
      <CssBaseline />
      <Grid className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        { user ? "" : 
        <form className={classes.form} noValidate>
          <StyledFirebaseAuth
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth()}
          />
          <Box mt={5}>
            <Copyright />
          </Box>
        </form>
        }
        
      </Grid>
      <Wave
        fill="#53131E"
        paused={false}
        options={{
          height: 70,
          amplitude: 50,
          speed: 0.45,
          points: 4
        }}
        style={{ height: '55%', backgroundColor: '#FAC9B8' }}
      />
      <PopupMusician
        buttonText="Edit"
        open={popupIsOpen}
        setOpen={setPopupIsOpen}
        user={user}
        authSendNewMusicianApi={authSendNewMusicianApi}
        loading={popupIsLoading}
        setLoading={setPopupIsLoading}
        errorText={popupErrorText}
        initialMusicianName={state}
      ></PopupMusician>
    </Page>
  );
};

export default LoginView;
